import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataGooglSheets: localStorage.getItem("dataGoogleSheets")
    ? JSON.parse(localStorage.getItem("dataGoogleSheets"))
    : null,
  updateDataGoogleSheets: null,
  newDataGoogleSheets: null,
  activeDataGoogleSheets: localStorage.getItem("activeDataGoogleSheets")
    ? JSON.parse(localStorage.getItem("activeDataGoogleSheets"))
    : null,
  isUpdateGoogleSheets: false,
  isLoadingGoogleSheets: false,
  isErrorGoogleSheets: false,
};

const googleSheetsSlice = createSlice({
  name: "googleSheets",
  initialState,
  reducers: {
    setDataGoogleSheets(state, action) {
      state.dataGooglSheets = action.payload;
    },
    setNewDataGoogleSheets(state, action) {
      state.newDataGoogleSheets = action.payload;
    },
    setUpdateDataGoogleSheets(state, action) {
      state.updateDataGoogleSheets = action.payload;
    },
    setIsUpdateGoogleSheets(state, action) {
      state.isUpdateGoogleSheets = action.payload;
    },
    setActiveDataGoogleSheets(state, action) {
      state.activeDataGoogleSheets = action.payload;
      localStorage.setItem(
        "activeDataGoogleSheets",
        JSON.stringify(action.payload)
      );
    },
    setIsLoadingGoogleSheets(state, action) {
      state.isLoadingGoogleSheets = action.payload;
    },
    setIsErrorGoogleSheets(state, action) {
      state.isErrorGoogleSheets = action.payload;
    },
  },
});

export const {
  setDataGoogleSheets,
  setNewDataGoogleSheets,
  setUpdateDataGoogleSheets,
  setIsUpdateGoogleSheets,
  setActiveDataGoogleSheets,
  setIsLoadingGoogleSheets,
  setIsErrorGoogleSheets,
} = googleSheetsSlice.actions;

export default googleSheetsSlice.reducer;
